module.exports = __webpack_public_path__ + "img/202209-xl.ffa1aaae.png";